import ajax from "../../lib/appfuse-react/core/ajax";

const memberService = {

    getInfo: async (url) => {
        const response = await ajax.get(url);
        return response.data;
    },

    update: async (url, data) => {
        const response = await ajax.patch(url, data);
        return response.data;
    }
}

export default memberService;